import { render } from "./petplan.vue?vue&type=template&id=0f483f92"
import script from "./petplan.vue?vue&type=script&lang=js"
export * from "./petplan.vue?vue&type=script&lang=js"

import "./petplan.vue?vue&type=style&index=0&id=0f483f92&lang=scss&Scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__